import React from 'react';

interface IconButtonProps {
  icon: React.ReactNode;
  className?: string;
  onClick?: () => void;
  title?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({ icon, className = '', onClick, title }) => (
  <button 
    onClick={onClick}
    title={title}
    className={`text-console-text/70 hover:opacity-80 transition-opacity active:scale-95 ${className}`}
  >
    {icon}
  </button>
);
